import * as React from 'react'
import { Site } from '@envato/foundation-types'
import get from 'lodash-es/get'

import ui from '../../../../common/constants/ui'
import { IItem } from '../../../../typings/searchResults'
import EnhancedLazyLoad from '../../../components/enhancedLazyLoad'
import ImagePlaceholder from '../../../components/imagePlaceholder'
import Preview from '../../itemCard/lockupPreview/preview'
import LockupRating from '../../itemCard/lockupRating'
import itemAspectRatio from '../../../../common/utils/itemAspectRatio'
import { getSrcSetData } from '../../../../common/utils/imageSrcSetHelpers'
import GridImage from '../photoduneGridItemCard/gridImage'

import AudioPlayerContainer from '../../audioPlayer/audioPlayerContainer'

import * as styles from './itemPreviewCard.module.css'

interface IProps {
  item: IItem
  onClick?: React.EventHandler<any>
  currentSite: Site
}

const ItemPreviewCard = ({ item, currentSite, onClick = () => {} }: IProps) => {
  const { url, name, author_url, author_username } = item
  const placeholderRatio = 300 / 590
  const aspectRatio = itemAspectRatio(item) || 1.0
  const src = get(item, 'previews.icon_with_audio_preview.mp3_url')
  const length = get(item, 'previews.icon_with_audio_preview.length')
  const imgSrcs = getSrcSetData(item.image_urls, 'w400', aspectRatio)
  const isAudio = currentSite === Site.audiojungle
  const isPhoto = currentSite === Site.photodune
  const rootStyle = isAudio ? styles.rootAudio : styles.root
  const infoStyle = isAudio ? styles.infoAudio : styles.info

  const renderPreview = () => {
    if (isPhoto) {
      return (
        <div className={styles.flexiImageWrapper}>
          <GridImage
            imgSrcs={imgSrcs}
            alt={item.name}
            imageClassName={styles.flexiImage}
          />
        </div>
      )
    }

    if (isAudio) {
      return (
        <div className={styles.audioPlayer}>
          <AudioPlayerContainer
            src={src}
            length={length}
            id={item.id}
            viewType="grid"
          />
        </div>
      )
    }

    return (
      <EnhancedLazyLoad
        offset={ui.lazyLoadOffset}
        placeholder={<ImagePlaceholder ratio={placeholderRatio} />}
      >
        <Preview item={item} onItemLinkClick={onClick} />
      </EnhancedLazyLoad>
    )
  }

  return (
    <div className={rootStyle}>
      {renderPreview()}

      <div className={infoStyle}>
        <div className={styles.linkArea}>
          <a href={url} onClick={onClick} className={styles.itemLink}>
            {name}
          </a>
        </div>
        <div className={styles.author}>
          <em> by </em>
          <a className={styles.authorLink} href={author_url.toLowerCase()}>
            {author_username}
          </a>
        </div>
        <div className={styles.rating}>
          <LockupRating item={item} />
        </div>
      </div>
    </div>
  )
}

export default ItemPreviewCard
